import React from 'react';
import EditorFeedbackIcon from '@atlaskit/icon/glyph/editor/feedback';
import { useIntl } from '@atlassian/jira-intl';
import { NewField } from '../../../common/ui/new-field';
import messages from './messages';

export const StakeholdersField = () => {
	const { formatMessage } = useIntl();
	return (
		<NewField
			icon={<EditorFeedbackIcon label="" />}
			title={formatMessage(messages.stakeholdersTitle)}
			description={formatMessage(messages.stakeholdersDescription)}
			link={{
				href: 'https://support.atlassian.com/jira-service-management-cloud/docs/how-can-i-add-and-manage-internal-stakeholders/',
				text: formatMessage(messages.stakeholdersLearnMoreLink),
				inProductHelpArticleId: '1uM1eoE33LGKdqDxsd3Jpg',
			}}
		/>
	);
};
